import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import { BaseQuery } from '../common/base-query.class';
export var SingleTypeQuery =
/*#__PURE__*/
function (_BaseQuery) {
  _inherits(SingleTypeQuery, _BaseQuery);

  function SingleTypeQuery(config, queryService, typeCodename) {
    var _this;

    _classCallCheck(this, SingleTypeQuery);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleTypeQuery).call(this, config, queryService));
    _this.config = config;
    _this.queryService = queryService;
    _this.typeCodename = typeCodename;
    _this._queryConfig = {};

    if (!typeCodename) {
      throw Error("Cannot create type query without the codename of the type");
    }

    return _this;
  }

  _createClass(SingleTypeQuery, [{
    key: "toPromise",
    value: function toPromise() {
      var _a;

      return this.queryService.getSingleType(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      var action = '/types/' + this.typeCodename;
      return _get(_getPrototypeOf(SingleTypeQuery.prototype), "resolveUrlInternal", this).call(this, action);
    }
  }, {
    key: "map",
    value: function map(json) {
      return this.queryService.mappingService.viewContentTypeResponse(json);
    }
  }]);

  return SingleTypeQuery;
}(BaseQuery);